module.exports = __webpack_public_path__ + "./PKPhoto_8aabce469421c7c03b579a7e5dad5df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/PKPhoto.png
// module id = 501
// module chunks = 0